/**
 * Asynchronously loads the component for ErrorPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./ErrorPage'));
